var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#D2D2D2",
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.62L15.19 17.81L20 13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.5199L16 25.0899L15 24.5199C12.8709 23.2907 11.103 21.5225 9.87423 19.3931C8.64543 17.2638 7.99901 14.8484 8 12.3899C8.00036 12.0392 8.09294 11.6947 8.26846 11.3911C8.44398 11.0874 8.69626 10.8353 9 10.6599L15.08 7.14993C15.3594 6.98745 15.6768 6.90186 16 6.90186C16.3232 6.90186 16.6406 6.98745 16.92 7.14993L23 10.6599C23.3037 10.8353 23.556 11.0874 23.7315 11.3911C23.9071 11.6947 23.9996 12.0392 24 12.3899C24.001 14.8484 23.3546 17.2638 22.1258 19.3931C20.897 21.5225 19.1291 23.2907 17 24.5199Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollIconGray);
export default __webpack_public_path__ + "static/media/Roll-icon-gray.06dcf3e0c3134d2f082b265a07c97539.svg";
export { ForwardRef as ReactComponent };